<template>
  <div
    class="c-view"
    :class="{
      'c-view--white': hasWhiteBackground,
      'c-view--no-scroll': noScroll,
      'c-view--bottom-padding': bottomPadding,
      'c-view--extra-bottom-padding': extraBottomPadding,
      'c-view--flex': flex
    }"
  >
    <slot />
  </div>
</template>

<script>
// @group Base Components
export default {
  name: 'OView',
  props: {
    hasWhiteBackground: {
      type: Boolean,
      default: false
    },
    noScroll: {
      type: Boolean,
      default: false
    },
    bottomPadding: {
      type: Boolean,
      default: false
    },
    extraBottomPadding: {
      type: Boolean,
      default: false
    },
    flex: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss">
.c-view {
  bottom: 0;
  height: 100%;
  left: 0;
  overflow: auto;
  position: absolute;
  right: 0;
  top: 0;
}

.c-view--flex {
  display: flex;
  flex-direction: column;
}

.c-view--white {
  background: #fff;
}

.c-view--no-scroll {
  overflow: hidden;
}

.c-view--bottom-padding {
  &:after {
    content: '';
    display: block;
    height: 19rem;
  }
}

.c-view--extra-bottom-padding {
  &:after {
    content: '';
    display: block;
    height: 12rem;
  }
}
</style>
